import Utils from 'services/utils';


/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * ViewsApi class.
 * Use this service to interact with API.
 */
export default class ViewsApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.listUrl = Utils.buildApiUrl('views.list');
    }

    /**
     * Get Views
     * @returns {promise}
     */
    getList(params = {}) {
        return this.$http.get(this.listUrl, { params }).then(responseDataExtractor);
    }

    /**
     * Create View
     * @param {Object} view - View object
     * @returns {promise}
     */
    createView(view) {
        return this.$http.post(this.listUrl, view).then(responseDataExtractor);
    }

    /**
     * Get View by given view id
     * @param {number} viewId - View id
     * @returns {promise}
     */
    getView(viewId) {
        const url = Utils.buildApiUrl('views.entity', { viewId });

        return this.$http.get(url).then(responseDataExtractor);
    }

    saveView(viewId, data) {
        const url = Utils.buildApiUrl('views.entity', { viewId });

        return this.$http.put(url, data).then(responseDataExtractor);
    }

    /**
     * Delete View by given view id
     * @param {number} viewId - View id
     * @returns {promise}
     */
    deleteView(viewId) {
        const url = Utils.buildApiUrl('views.entity', { viewId });

        return this.$http.delete(url).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/views/views.service.js